import { useEffect, useLayoutEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { TeamDescription } from '../../../components/Team/TeamDescription'
import { TeamInfo } from '../../../components/Team/TeamInfo'
import { Box, CircularProgress, Stack, useMediaQuery } from '@mui/material'
import { PureLightTheme } from '../../../styles/theme'
import { MainBox, SideBox, StackStyle } from './style'
import { NotFound } from '../../../components/ui-kit/NotFound'
import { useGetTeamQuery, useTrackTeamViewMutation } from '../../../api/teams'

export const TeamPage = () => {
  useLayoutEffect(() => {
    document.title = 'Команда'
  }, [])

  const { id } = useParams<{ id: string }>()
  const isMobile = useMediaQuery(PureLightTheme.breakpoints.down('md'))
  const viewedTeamIdRef = useRef<number | null>(null)

  const { data: team, isLoading, isError, refetch } = useGetTeamQuery(
    { id: id ?? '' },
    { skip: !id },
  )
  const [trackTeamView] = useTrackTeamViewMutation()

  useEffect(() => {
    if (!team?.hasPendingJoinRequest) return

    const onVisibilityChange = () => {
      if (document.visibilityState !== 'visible') return
      refetch()
    }

    document.addEventListener('visibilitychange', onVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [team?.hasPendingJoinRequest, refetch])

  useEffect(() => {
    if (!team?.id || viewedTeamIdRef.current === team.id) {
      return
    }
    viewedTeamIdRef.current = team.id
    trackTeamView({ teamId: team.id })
  }, [team?.id, trackTeamView])

  if (isLoading) {
    return (
      <Stack alignItems="center" justifyContent="center" height="100%">
        <CircularProgress />
      </Stack>
    )
  }

  if (isError || !team) {
    return <NotFound text="Команда не найдена" />
  }

  return (
    <Stack direction="row" sx={StackStyle}>
      <Box sx={MainBox}>
        <TeamDescription team={team} />
      </Box>
      {!isMobile && (
        <Box sx={SideBox}>
          <TeamInfo team={team} />
        </Box>
      )}
    </Stack>
  )
}
